export default {
    filters: {
        title: "Filtros",
        removeFilter: "Remover Filtro",
        filterIntensity: "Intensidade do Filtro",
        duotone: {
            title: "Duotone",
            desert: "Deserto",
            peach: "Pêssego",
            clash: "Conflito",
            plum: "Ameixa",
            breezy: "Breezy",
            deepBlue: "Azul profundo",
            frog: "Sapo",
            sunset: "Pôr do sol",
        },
        blackAndWhite: {
            title: "Preto e Branco",
            ad: "1920 D.C",
            greyed: "Cinza",
            dusty: "Empoeirado",
            litho: "Litografia",
            sepia: "Sépia",
            weathered: "Desgastado",
            hardStuff: "Coisas difíceis",
        },
        vintage: {
            title: "Vintage ",
            polaroid: "Polaroid",
            sunny: "Anos Ensolarados 70",
            oldTimer: "Velho tempo",
            inferno: "Inferno",
            snappy: "Esperto",
        },
        smooth: {
            title: "Suave",
            chestnut: "Castanha",
            softy: "Suavinho",
            pebble: "Pebble - Seixo",
            moss: "Musgo",
            lemon: "Limão",
            greenGap: "Brecha verde",
        },
        cold: {
            title: "Frio",
            colla: "Colla",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levantamento",
            zephyr: "Zéfiro",
        },
        warm: {
            title: "Quente",
            golden: "Dourado",
            lowFire: "Fogo baixo",
            sunrise: "Alvorecer",
            flatBack: "Costas retas",
            pumpkin: "Abóbora",
        },
    },
};
